import { pick } from 'underscore';
import { formatRSAObject } from '@bingads-webui-campaign-react/responsive-search-ad-editor';

const whitelistedSchemaPropertyKeysForModel = [
  'Id',
  'FinalUrls',
  'MobileFinalUrls',
  'DisplayUrl',
  'Path1',
  'Path2',
  'Headlines',
  'Descriptions',
  'TrackingUrlTemplate',
  'FinalUrlSuffix',
  'UrlCustomParameters',
  'Type',
];

export const viewModelToModelForRSA = (adViewModel, campaignId, adGroupId) => ({
  ...pick(formatRSAObject(adViewModel), whitelistedSchemaPropertyKeysForModel),
  ...adViewModel.Id ? { Id: adViewModel.Id } : {},
  Campaign: { Id: campaignId },
  AdGroup: { Id: adGroupId },
});

export const bulkModelToViewModelForRSA = ({
  adModel,
  errors,
}) => ({
  ...pick(adModel, whitelistedSchemaPropertyKeysForModel),
  errors,
});
